import React, { PureComponent } from 'react';
import { withStyles, Paper, Table, TableHead, TableBody, TableRow, TableCell, 
  Toolbar, Typography,} from '@material-ui/core';
import PropTypes from 'prop-types';

const styles = theme => ({
  root: {
    maxWidth: 1060,
    margin: 'auto',
  },
  toolbar: {
    paddingRight: theme.spacing.unit,
  },
  spacer: {
    flexGrow: 1,
  },
  title: {
    flex: '0 0 auto',
  },
  tablerow: {
    height: 36
  },
});

class CoachesList extends PureComponent {

  componentDidMount() {
    const { fetchingCoachesList, getCoachesList, userSeason } = this.props;
    if ((fetchingCoachesList !== 'Loading' || fetchingCoachesList !== 'Loaded') &&
        (userSeason)){
      getCoachesList(userSeason);
    }
  }

  componentDidUpdate(prevProps) {
    const { userSeason, getCoachesList } = this.props;
    if (userSeason !== prevProps.userSeason) {
      getCoachesList(userSeason);
    }
  }

  render() {
    const { fetchingCoachesList } = this.props;
    const { classes } = this.props;

    return (
      <Paper className={classes.root}>
        <Toolbar className={classes.toolbar}>
          <div  className={classes.title}>
            <Typography variant="h5">Coaches Table</Typography>
          </div>
          <div className={classes.spacer} />
        </Toolbar>
        <Table padding="none">
          <TableHead>
            <TableRow>
              <TableCell align="center"><Typography variant="body1">Member ID</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">Coach</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">Division</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">Team</Typography></TableCell>
            </TableRow>
          </TableHead>
          {fetchingCoachesList === 'Loaded' && this.renderTableBody()}
        </Table>
      </Paper>
      );
    }

  renderTableBody() {
    const { classes, coachesList } = this.props;

    return (
      <TableBody>
        {coachesList.map(coach => {
          return (
            <TableRow className={classes.tablerow} key={`${coach.seasonId}-${coach.divisionId}-${coach.memberId}-${coach.teamName}`} hover>
              <TableCell align="center"><Typography variant="body1">{coach.memberId}</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">{coach.firstName} {coach.lastName}</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">{coach.divisionName}</Typography></TableCell>
              <TableCell padding="dense"><Typography variant="body1">{coach.teamName}</Typography></TableCell>
            </TableRow>
          );
      })}
      </TableBody>
    );
  }
}

CoachesList.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(CoachesList);



// WEBPACK FOOTER //
// ./src/components/CoachesList.js